import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const linkPage = () => import('../views/linkPage')
const casePage = () => import('../views/casePage')
const planPage = () => import('../views/planPage')
const servicePage = () => import('../views/servicePage')


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      component: HomePage
    },
    {
      path: '/link',
      component: linkPage
    },
    {
      path: '/case',
      component: casePage
    },
    {
      path: '/plan',
      component: planPage
    },
    {
      path: '/service',
      component: servicePage
    },
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js